// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3YTJf","footer":"ModalCreateQualiphyProcedure_footer__2ADdE","additionData":"ModalCreateQualiphyProcedure_additionData__9R8lU"};